module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Files/Group-folders-fef2c454e544f2d17adcf6c25c3190f4.svg";